import { put, call } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';
import { insurancesAPI } from 'services/apiRest';

import InsurancesActions from '../ducks/insurances';

export function* getInsurances() {
  try {
    const insurances = yield call(insurancesAPI.listar);

    yield put(InsurancesActions.getInsurancesSuccess(insurances));
  } catch (err) {
    console.error('Erro ao buscar seguros:', err);
    yield put(InsurancesActions.getInsurancesFailure(err));
  }
}

export function* addInsurance({ insurance, closeModal }) {
  try {
    const newInsurance = yield call(insurancesAPI.criar, insurance);

    yield put(InsurancesActions.addInsuranceSuccess(newInsurance));
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Seguro cadastrado com sucesso',
      })
    );
    if (closeModal) closeModal();
  } catch (err) {
    console.error('Erro ao cadastrar seguro:', err);
    yield put(InsurancesActions.addInsuranceFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro ao cadastrar seguro',
        message: err.message || 'Erro desconhecido',
      })
    );
  }
}

export function* updateInsurance({ id, insurance, closeModal }) {
  try {
    const updatedInsurance = yield call(insurancesAPI.atualizar, id, insurance);

    yield put(InsurancesActions.updateInsuranceSuccess(updatedInsurance));
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Seguro atualizado com sucesso',
      })
    );
    if (closeModal) closeModal();
  } catch (err) {
    console.error('Erro ao atualizar seguro:', err);
    yield put(InsurancesActions.updateInsuranceFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro ao atualizar seguro',
        message: err.message || 'Erro desconhecido',
      })
    );
  }
}

export function* removeInsurance({ id }) {
  try {
    yield call(insurancesAPI.deletar, id);

    yield put(InsurancesActions.removeInsuranceSuccess({ id }));
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Seguro excluído com sucesso',
      })
    );
  } catch (err) {
    console.error('Erro ao excluir seguro:', err);
    yield put(InsurancesActions.removeInsuranceFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro ao excluir seguro',
        message: err.message || 'Erro desconhecido',
      })
    );
  }
}
